import Image from 'global/Image';

import { PanelContainer, PanelIconContainer } from '../styled';

interface Props {
  imageSrc?: string;
  text?: string;
}

export default function InfoPanel({
  imageSrc = 'icon/fr/icon-sand-clock.svg',
  text = '',
}: Props) {
  return (
    <PanelContainer>
      <PanelIconContainer>
        <Image src={imageSrc} />
      </PanelIconContainer>
      <p>{text}</p>
    </PanelContainer>
  );
}
